export default "__VITE_ASSET__Dph3Bs19__"